import './index.style.less'
import { Form, Select, Typography } from 'antd'
import MeasurementWeight from './MeasurementWeight'
import useMasterData from '@/hook/MasterData'
import { useEffect, useState } from 'react'
import { find, get, lowerCase, orderBy } from 'lodash'
import { isEmptyValue, JSONStringify } from '@/utils/common'
import { getFieldName } from '../../EditOrder.helper'
import FormItem from '../FormItem/FormItem'
import ModalUploadPom from './components/ModalUploadPom/ModalUploadPom'

import { useQuery } from 'react-query'
import { getAllDefectsGroup } from '../../../Order.service'

import { AQL_TYPE_VALUE } from '@/constant/aql'
import { useHasMeasurementAql, useAqlOptions } from '@/hook/useMeasurementAql'

const { Title } = Typography
interface Props {
  fields: any
  data?: any
  setField: (fields) => void
  form: any
  orderSetting: any
}

function ProductRequirementForm(props: Props) {
  const { measurement, attributes, information, product_weight } = props.data
  const [aqlList, setaqlList] = useState([])
  const [measurementAqlList, setMeasurementAqlList] = useState([])
  const [defectListdata, setDefectListData] = useState([])

  const { data } = useMasterData()
  const [modalImport, setModalImport] = useState(false)
  const [measurementFromFile, setmeasurementFromFile] = useState([])

  const { data: dataDefectGroup } = useQuery(['GET_DEFECT_GROUP'], async () => {
    const data = await getAllDefectsGroup()

    setDefectListData(
      data?.data?.data?.map((item) => {
        return {
          label: item?.name,
          value: item?.id,
          is_default: item?.is_default,
        }
      })
    )
    return data?.data?.data
  })

  const hasMeasurementAqlSetting = useHasMeasurementAql()

  const { data: rawAqlList } = useAqlOptions(AQL_TYPE_VALUE.DEFAULT)
  const { data: rawMeasurementAqlList } = useAqlOptions(
    AQL_TYPE_VALUE.MEASUREMENT,
    !!hasMeasurementAqlSetting
  )

  useEffect(() => {
    if (rawAqlList) setaqlList(rawAqlList)
    if (rawMeasurementAqlList) setMeasurementAqlList(rawMeasurementAqlList)
  }, [rawAqlList, rawMeasurementAqlList])

  useEffect(() => {
    const aqlValue = information?.find((item) => item.field == 'aql')
    const defectGroupValue = information?.find(
      (item) => item.field == 'defect_group'
    )
    if (aqlList?.length > 0) {
      checkExistAqlValueInList(aqlList, aqlValue)
    }
    checkExistDefectGroupValueInList(defectListdata, defectGroupValue?.value)

    const measurementAqlValue = measurement?.find((item) => item.field === 'measurement_aql')
    if (measurementAqlValue) {
      const parentId = get(measurementAqlValue, 'parent.id', '') || get(measurementAqlValue, 'parent_id', '')
      const selectedId = parentId || measurementAqlValue.value
      if (selectedId) {
        props.form.setFieldValue('measurement_aql', selectedId)
      }
    }
  }, [data, dataDefectGroup, measurement, aqlList])

  const checkExistAqlValueInList = (list, aqlValue) => {
    if (isEmptyValue(aqlValue)) {
      const defaultAQL = list?.find((item) => item?.is_default)
      props.form.setFieldValue('aql', defaultAQL?.value)
    } else {
      const parentId =
        get(aqlValue, 'parent.id', '') || get(aqlValue, 'parent_id', '')
      const getAqlByParentId = find(list, (item) => item.value === parentId)
      const aqlName = get(aqlValue, 'value.name')
      const getAqlByName = find(list, (item) => item.label === aqlName)
      if (getAqlByParentId || getAqlByName) {
        // value is the id or parent_id of aql
        const data = getAqlByParentId?.value || getAqlByName?.value
        props.form.setFieldValue('aql', data)
      } else {
        props.form.setFieldValue('aql', null)
      }
    }
  }

  const checkExistDefectGroupValueInList = (list, value) => {
    if (isEmptyValue(value)) {
      const defaultDefectList = list?.find((item) => item?.is_default)
      props.form.setFieldValue('defect_group', defaultDefectList?.value)
    } else {
      if (list?.some((item) => item?.value == value)) {
        props.form.setFieldValue('defect_group', value)
      } else {
        props.form.setFieldValue('defect_group', null)
      }
    }
  }

  return (
    <div className="order-requirement-form">
      <Title level={3}>Information</Title>
      <Form name="requirement" requiredMark={true} form={props.form}>
        <div className="row-container">
          {orderBy(information, ['display_order'], 'asc')?.map(
            (item, index) => {
              if (item.data_type == 'file') {
                return (
                  <FormItem
                    orderSetting={props.orderSetting}
                    key={index}
                    item={item}
                    allowLargeFile
                  />
                )
              } else if (item.field == 'defect_group') {
                return (
                  <Form.Item
                    key={index}
                    name={item.field}
                    labelCol={{ span: 6 }}
                    labelAlign="left"
                    label={
                      getFieldName(
                        props.orderSetting?.field_names,
                        item.field
                      ) ?? item.name
                    }
                    required={item.required}
                    rules={
                      item.required && [
                        {
                          required: true,
                          message: 'This field is required',
                        },
                      ]
                    }
                  >
                    <Select
                      placeholder="Select"
                      allowClear
                      size="large"
                      dropdownRender={(menu) => (
                        <div
                          onMouseDown={(e) => {
                            e.preventDefault()
                            e.stopPropagation()
                          }}
                        >
                          {menu}
                        </div>
                      )}
                      options={defectListdata}
                    />
                  </Form.Item>
                )
              }
              return (
                // eslint-disable-next-line react/jsx-key
                <Form.Item
                  key={index}
                  name={item.field}
                  labelCol={{ span: 6 }}
                  labelAlign="left"
                  label={
                    getFieldName(props.orderSetting?.field_names, item.field) ??
                    item.name
                  }
                  required={item.required}
                  rules={
                    item.required && [
                      {
                        required: true,
                        message: 'This field is required',
                      },
                    ]
                  }
                >
                  <Select
                    placeholder="Select"
                    allowClear
                    size="large"
                    dropdownRender={(menu) => (
                      <div
                        onMouseDown={(e) => {
                          e.preventDefault()
                          e.stopPropagation()
                        }}
                      >
                        {menu}
                      </div>
                    )}
                    options={aqlList}
                  />
                </Form.Item>
              )
            }
          )}
        </div>
      </Form>
      <MeasurementWeight
        orderSetting={props.orderSetting}
        data={
          isEmptyValue(measurementFromFile) ? measurement : measurementFromFile
        }
        form={props.form}
        title="Measurement"
        sizes={attributes}
        onClick={() => setModalImport(true)}
        renderHeader={
          hasMeasurementAqlSetting ? (
            <Form.Item
              name="measurement_aql"
              labelCol={{ span: 8 }}
              labelAlign="left"
              label="Measurement AQL"
              style={{ marginBottom: 0 }}
            >
              <Select
                allowClear
                showSearch
                placeholder="Select"
                size="large"
                options={measurementAqlList}
                optionFilterProp="label"
              />
            </Form.Item>
          ) : null
        }
      />
      <MeasurementWeight
        orderSetting={props.orderSetting}
        data={product_weight}
        sizes={attributes}
        form={props.form}
        onClick={null}
        title="Weight"
      />
      {modalImport && (
        <ModalUploadPom
          visible={modalImport}
          onClose={() => setModalImport(false)}
          data={props.data}
          onSave={(data) => {
            const tmpMeasurement = [...measurement]
            const tmp = tmpMeasurement.find(
              (item) => item.field == 'measurementSpec'
            )
            tmp.value = data
            tmpMeasurement.splice(
              measurement.findIndex((item) => item.name == 'name'),
              1,
              tmp
            )
            setmeasurementFromFile(tmpMeasurement)
          }}
        />
      )}
    </div>
  )
}

export default ProductRequirementForm
